import React, { createContext, useContext, useState, useEffect } from 'react';

export interface CookieConsent {
  essential: boolean;
  analytics: boolean;
  externalMedia: boolean;
}

interface CookieContextType {
  consent: CookieConsent | null;
  updateConsent: (newConsent: CookieConsent) => void;
  showBanner: boolean;
  setShowBanner: (show: boolean) => void;
}

const CookieContext = createContext<CookieContextType | undefined>(undefined);

export const COOKIE_STORAGE_KEY = 'otto_lilienthal_cookie_consent';

export const CookieProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [consent, setConsent] = useState<CookieConsent | null>(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const storedConsent = localStorage.getItem(COOKIE_STORAGE_KEY);
    if (storedConsent) {
      try {
        setConsent(JSON.parse(storedConsent));
      } catch (e) {
        console.error('Failed to parse cookie consent', e);
        setShowBanner(true);
      }
    } else {
      setShowBanner(true);
    }
  }, []);

  const updateConsent = (newConsent: CookieConsent) => {
    setConsent(newConsent);
    localStorage.setItem(COOKIE_STORAGE_KEY, JSON.stringify(newConsent));
    setShowBanner(false);
  };

  return (
    <CookieContext.Provider value={{ consent, updateConsent, showBanner, setShowBanner }}>
      {children}
    </CookieContext.Provider>
  );
};

export const useCookieConsent = () => {
  const context = useContext(CookieContext);
  if (context === undefined) {
    throw new Error('useCookieConsent must be used within a CookieProvider');
  }
  return context;
};



